export default __webpack_public_path__ + "static/media/property-gallery4.4bc66d3f.webp";